import React from "react";
import Verification from "@components/verification";
import {TRUE_FALSE_VALUES} from "../../../../constants/commonConstants";
import { useFormikContext } from "formik";
import { useSetDefaultValue } from "@hooks";

const name = "foreseeableChanges";

export default function YesNo() {
    const { handleChange, handleBlur, values, errors, touched } = useFormikContext();
    useSetDefaultValue(name);

    return (
        <>
            <Verification
                title={(
                    <> Are you aware of any reason why your financial circumstances might change in the near future? </>
                )}
                leftButtonProps={{ value: TRUE_FALSE_VALUES.TRUE, checked: values[name] === TRUE_FALSE_VALUES.TRUE, id:"foreseeableChangesYes" }}
                leftButtonLabel="Yes"
                rightButtonProps={{ value: TRUE_FALSE_VALUES.FALSE, checked: values[name] === TRUE_FALSE_VALUES.FALSE, id:"foreseeableChangesNo" }}
                rightButtonLabel="No"
                
                name={name}
                value={values[name]}
                onChange={handleChange}
                onBlur={handleBlur}
                errorMessage={touched[name] ? errors[name] : ""}
            />
        </>
    );
}
